<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :title="'Install'" />

        <v-container class="section-block">

            <v-row>
                <v-col class="col-12 col-lg-3 col-sm-6">
                    <v-img :aspect-ratio="4/3" :src="images.browse" controls></v-img>
                    <h2>Browsing</h2>
                    <p>
                        There are a lot of assets on Moonbase and not all of them will work inside of After Effects. When you open Ae plugin, you will be presented with a filtered version of your Moonbase library showing a grid of only Ae assets. 
                    </p>
                    <p>
                        Assets are organized into libraries. Switching between libraries is done from the top left menu. Libraries with Ae assets will appear within this menu. 
                    </p>
                </v-col>

                <v-col class="col-12 col-lg-3 col-sm-6">
                    <v-img :aspect-ratio="4/3" :src="images.manage" controls></v-img>
                    <h2>Managing</h2>
                    <p>
                        Organization of assets is handled from within the Moonbase app. All uploaded assets will be placed within the Imported library at the top of your library list. Simply drag the asset to another library to move it. 
                    </p>
                    <p>
                        Asset metadata may be edited by right clicking the asset or from the edit menu of the asset view.
                    </p>
                </v-col>

                <v-col class="col-12 col-lg-3 col-sm-6">
                    <v-img :aspect-ratio="4/3" :src="images.share" controls></v-img>
                    <h2>Sharing</h2>
                    <p>
                        By default, uploaded assets are private. 
                        To share assets with others they must be moved into a shared library within the Moonbase app. 
                    </p>
                    <p>
                        While viewing an owned library, click <strong>Edit Library</strong> and add additional owners, editors or viewers by LDAP or group name.
                    </p>
                </v-col>
                <v-col class="col-12 col-lg-3 col-sm-6" id="install">
                    <v-img :aspect-ratio="4/3" :src="images.install" controls></v-img>
                    <h2>Install</h2>
                    <p>
                        The Moonbase Ae plugin is bundled with the <a href="https://constellation.googleplex.com/app/moonbase">Moonbase app</a>. 
                        To install, open Moonbase and navigate to top menu Plugins > Install After Effects Plugin. 
                        You will be asked for you system password. 
                    </p>
                    <p>
                        Restart Ae and Moonbase will be available in the top menu Window > Extensions > Moonbase. 
                        Be sure you are logged into Moonbase in order to access assets
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="col-12 col-md-7">
                    <v-img :src="images.import"></v-img>
                </v-col>
                <v-col class="col-12 col-md-5">
                    <h2 style="margin-top: 0">Import assets</h2>
                    <p>
                        After opening the Moonbase panel within Ae, downloadable assets will may be seen within the grid. 
                        Roll over an asset and click to download. 
                        The downloaded asset will be imported into the current Ae project. 
                    </p>
                    <p>
                        Additional logic will be used at import to try and simplify the project. 
                        If a single comp with no footage is imported, the layers of the comp will be copied into the open comp and the imported folder removed from the project window.
                    </p>
                    <p>
                        <strong>Offline access</strong> - Asset files with a blue checkmark in the corner are available for offline use and do not require downloading. 
                    </p>
                </v-col>
            </v-row>


            <v-row>
                <v-col class="col-12 col-md-7">
                    <v-img :src="images.upload"></v-img>
                </v-col>
                <v-col class="col-12 col-md-5">
                    <h2 style="margin-top: 0">Upload assets</h2>
                    <p>
                        <ol>
                            <li>Navigate to the top left menu of the panel and click <strong>Upload Asset</strong></li>
                            <li>Name the asset</li>
                            <li>Add an asset thumbnail image</li>
                            <li>Save the Ae project</li>
                            <li>Click <strong>Collect Project</strong>. 
                            This project will be collected, zipped up and the path will automatically added to the Upload window.</li>
                            <li>(Optional) Click <strong>Test Import</strong> to confirm that the project being upload is what you wish to save</li>
                            <li>Click <strong>Upload</strong></li>
                        </ol>
                    </p>
                    <p>
                        Alternativly, you may manually navigate to a .zip file containing a collected Ae project.
                        </p>
                    <p>
                        Moonbase was designed to be used as a private or a shared library.
                        Motion assets may be uploaded to Moonbase and will be available locally for later use.
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="col-12 col-sm-8 col-md-6">
                    <h2>Thanks</h2>
                    <p>This project is a collaboration with <a href="https://moma.corp.google.com/person/rcameron@google.com">Rich Cameron</a>. His knowledge and patience were invaluable in helping me understand some of the deeper concepts involved in building onto a wide-reaching platform.</p>
                    <p>The initial concept for this system dates back to 2016 when a Drive folder was all that existed to organize Ae files between motion designers. Thanks to <a href="https://moma.corp.google.com/person/jfleetwo@google.com">Josh</a> and <a href="https://moma.corp.google.com/person/woonji@google.com">Woonji</a> for letting me pursue this.</p>
                </v-col>
            </v-row>
        </v-container>

    
    <!-- <InstallInfo id="install" :projectInfo="projectInfo" /> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'moonbase',
  components: {
  },
  data: () => ({
      images: {
            browse: require('../assets/images/Moonbase_Browse.png'),
            manage: require('../assets/images/Moonbase_Managing.png'),
            share: require('../assets/images/Moonbase_Sharing.png'),
            install: require('../assets/images/Moonbase_Install.png'),
            import: require('../assets/gif/Moonbase_import.gif'),
            upload: require('../assets/gif/Moonbase_upload.gif'),
        },
        video: {
            updateKeyframes: require('../assets/video/Dotkit-UpdateKeys.mp4'),
        },
      projectInfo: {
          name: 'Moonbase Ae Plugin',
          subtitle: 'The source of truth for motion assets',
          download: 'https://constellation.googleplex.com/app/moonbase',
          updated: 'Mar 12, 2020',
          version: '1.2',
          about:    `Built by <a href="https://constellation.googleplex.com/" target="_blank">Constellation</a>, Moonbase is the syncronized solution for accessing and sharing visual design assets across Google.
                    Built on top of Moonbase, Moonbase for Ae is the first ever shared library of motion assets - inside or outside of Google. It was designed to function as a private library and enable access to the wider source of standardized elements. Shared assets reduce redundancy to help utilize motion more effectivly.`
      },
  }),
}
</script>

<style scoped>

/* .img-block {
    margin: 36px auto;
}
.v-img {
    object-fit: contain;
} */
</style>